/**
 * htmls used in ng-include are not required automatically, so import them here
 *
 * Please do not use ng-include for new implementations!
 *
 */
import 'app/includes/generalValidationError.html';
import 'app/includes/generalError.html';
import 'app/includes/conversions-deal-id-max-capacity.html';
import 'app/includes/wizard-template.html';
import 'app/includes/network-point-input-summary.html';
import 'app/includes/quantity-validation-errors.html';
import 'app/includes/storage-booking-input-summary.html';

import 'app/_directives/pagination-range-inline.directive.html';
import 'app/_directives/pagination-pages-inline.directive.html';
import 'app/_directives/pagination-controls.directive.html';

import 'app/create-proposal/create-proposal-stage-one.html';
import 'app/create-proposal/create-proposal-stage-two.html';
import 'app/create-proposal/create-proposal-stage-three.html';
import 'app/create-proposal/create-proposal-stage-four.html';
import 'app/create-proposal/create-proposal-stage-five.html';
import 'app/create-proposal/create-proposal-input-summary.html';

import 'app/account-settings/contracting-services.html';

import 'app/platform-settings/view.html';
import 'app/platform-settings/secondary-trading.html';
import 'app/platform-settings/network-points.html';
import 'app/platform-settings/dashboard.html';
import 'app/platform-settings/new-trader-list.html';
import 'app/platform-settings/new-favorite-network-point.html';
import 'app/platform-settings/new-quick-filter.html';
import 'app/platform-settings/new-trading-condition.html';
import 'app/platform-settings/quick-filters.html';

import 'app/dashboard/dashboard.html';
import 'app/dashboard/current-auctions.html';
import 'app/dashboard/favorite-network-points.html';
import 'app/dashboard/activities.html';
import 'app/dashboard/trade-proposals.html';
import 'app/tso-dashboard/tso-dashboard.html';

import 'app/proposal-details/proposal-response.html';

import 'app/reporting/upload-report.html';
import 'app/reporting/contract-positions-report.html';
import 'app/reporting-details/surrender-fcfs-contracts-details.html';

import 'app/storage-booking-wizard/storage-booking-wizard-fcfsoffer-ok.html';
import 'app/storage-booking-wizard/storage-booking-wizard-fcfsoffer-ok-alternatives.html';
import 'app/storage-booking-wizard/input-summary.html';
import 'app/storage-booking-wizard/storage-booking-wizard.component.html';

import 'app/storage-admin/storage-admin-rest-api-congratulations-modal.html';
import 'app/storage-admin/storage-admin-allocation-algorithm-comfirm-modal.html';
import 'app/storage-admin/storage-admin-allocation-algorithm-disable-modal.html';
import 'app/storage-admin/storage-admin-allocation-algorithm-downgrade-modal.html';

import 'app/_directives/aggregated-status-popover-inactive.html';
import 'app/_directives/aggregated-status-popover-active.html';
import 'app/product-upload-wizard/summaryOverview.html';

import 'app/_directives/pkp-confirm-open.directive.html';
